import React__default, { useMemo } from 'react';
import cn from 'classnames';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { getNextInteger } from '../../utils.js';
import styles from 'ui-components/Input.scss';

var _excluded = ["slotLeft", "slotRight", "id", "className", "wrapperClassName", "labelClassName", "name", "label", "errors", "value", "variant"];
var getId = function getId(id) {
  return id !== null && typeof id !== "undefined" ? id : "_id_" + getNextInteger();
};
var InputErrors = function InputErrors(_ref) {
  var errors = _ref.errors,
    className = _ref.className,
    inputId = _ref.inputId;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.errors, className)
  }, errors.map(function (x) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: x,
      id: "error-" + encodeURIComponent(x) + "-" + inputId,
      className: styles.error
    }, x);
  }));
};
var Input = /*#__PURE__*/React__default.forwardRef(function (_ref2, ref) {
  var _cn, _cn2, _cn3, _cn4, _cn5;
  var slotLeft = _ref2.slotLeft,
    slotRight = _ref2.slotRight,
    _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? null : _ref2$id,
    className = _ref2.className,
    wrapperClassName = _ref2.wrapperClassName,
    labelClassName = _ref2.labelClassName,
    name = _ref2.name,
    label = _ref2.label,
    errors = _ref2.errors,
    value = _ref2.value,
    variant = _ref2.variant,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded);
  var idProp = useMemo(function () {
    return getId(id);
  }, [id]);
  var inputLabel = label !== undefined ? /*#__PURE__*/React__default.createElement("label", {
    htmlFor: idProp,
    className: cn(styles.label, labelClassName)
  }, label) : null;
  var input = /*#__PURE__*/React__default.createElement("input", _extends({}, props, {
    ref: ref,
    id: idProp,
    className: cn(styles.input, className),
    name: name,
    value: value,
    "aria-invalid": errors && errors.length > 0,
    "aria-describedby": errors && errors.length > 0 ? errors.map(function (error) {
      return "error-" + encodeURIComponent(error) + "-" + idProp;
    }).join(" ") : undefined
  }));
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.block, (_cn = {}, _cn[styles[variant]] = Boolean(variant), _cn), (_cn2 = {}, _cn2[styles.error] = errors && errors.length > 0, _cn2), (_cn3 = {}, _cn3[styles.empty] = typeof value === "undefined" || value === null || value === "", _cn3), (_cn4 = {}, _cn4[styles.hasSlotLeft] = Boolean(slotLeft), _cn4), (_cn5 = {}, _cn5[styles.hasSlotRight] = Boolean(slotRight), _cn5), wrapperClassName)
  }, slotLeft !== null && typeof slotLeft !== "undefined" && /*#__PURE__*/React__default.createElement("div", {
    className: styles.slotLeft
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.slot
  }, slotLeft)), variant === "float" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, input, inputLabel) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, inputLabel, input)), errors && errors.length > 0 && /*#__PURE__*/React__default.createElement(InputErrors, {
    errors: errors,
    inputId: idProp
  }), slotRight !== null && typeof slotRight !== "undefined" && /*#__PURE__*/React__default.createElement("div", {
    className: styles.slotRight
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.slot
  }, slotRight)));
});

export { Input, InputErrors };
//# sourceMappingURL=index.js.map
